
import { TypingEffectsSettings, useTypingEffectsPreferences } from '@/components/editor/typing-effects';
import { useTheme } from "@/components/providers/theme-provider";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";
import { Monitor, Moon, Palette, Sun, Volume2 } from 'lucide-react';

export function SectionGeneral() {
    const { theme, setTheme } = useTheme();

    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-medium">Appearance</h3>
                <p className="text-sm text-muted-foreground">
                    Customize the look and feel of the application.
                </p>
            </div>
            <Separator />

            <div className="grid gap-6">
                {/* Theme Settings */}
                <Card className="border-muted bg-card/50">
                    <CardHeader>
                        <div className="flex items-center gap-2">
                            <div className="p-2 bg-primary/10 rounded-lg">
                                <Palette className="h-5 w-5 text-primary" />
                            </div>
                            <div>
                                <CardTitle className="text-base">Theme Preferences</CardTitle>
                                <CardDescription>
                                    Choose your preferred color scheme
                                </CardDescription>
                            </div>
                        </div>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="flex items-center justify-between">
                            <Label htmlFor="theme-select" className="flex flex-col gap-1">
                                <span>Interface Theme</span>
                                <span className="font-normal text-xs text-muted-foreground">Select a theme that suits your working environment</span>
                            </Label>
                            <Select value={theme} onValueChange={setTheme}>
                                <SelectTrigger id="theme-select" className="w-[180px]">
                                    <SelectValue />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="light"><div className="flex items-center gap-2"><Sun className="h-3 w-3" /> Light</div></SelectItem>
                                    <SelectItem value="dark"><div className="flex items-center gap-2"><Moon className="h-3 w-3" /> Dark</div></SelectItem>
                                    <SelectItem value="system"><div className="flex items-center gap-2"><Monitor className="h-3 w-3" /> System</div></SelectItem>
                                    <SelectItem value="novel">Novel</SelectItem>
                                    <SelectItem value="claude">Lavender</SelectItem>
                                    <SelectItem value="claude-orange">Claude</SelectItem>
                                    <SelectItem value="caffeine">Caffeine</SelectItem>
                                    <SelectItem value="arc-rose">Arc Rose</SelectItem>
                                </SelectContent>
                            </Select>
                        </div>
                    </CardContent>
                </Card>

                {/* Typing Effects Settings */}
                <TypingEffectsSettingsCard />
            </div>
        </div>
    );
}

function TypingEffectsSettingsCard() {
    const { config, updateConfig } = useTypingEffectsPreferences();

    return (
        <Card className="border-muted bg-card/50">
            <CardHeader>
                <div className="flex items-center gap-2">
                    <div className="p-2 bg-primary/10 rounded-lg">
                        <Volume2 className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                        <CardTitle className="text-base">Typing Experience</CardTitle>
                        <CardDescription>
                            Configure audio and visual feedback while writing
                        </CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent>
                <TypingEffectsSettings
                    config={config}
                    onConfigChange={updateConfig}
                />
            </CardContent>
        </Card>
    );
}
